function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = [
    "children",
    "className",
    "classes"
];
import * as React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { styled } from '@mui/material/styles';
import { unstable_generateUtilityClasses as generateUtilityClasses } from '@mui/utils';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import { forwardRef } from '@mui/x-internals/forwardRef';
import { useGridApiContext } from "../../hooks/utils/useGridApiContext.js";
import { useGridRootProps } from "../../hooks/utils/useGridRootProps.js";
import { jsx as _jsx } from "react/jsx-runtime";
export var gridPanelClasses = generateUtilityClasses('MuiDataGrid', [
    'panel',
    'paper'
]);
var GridPanelRoot = styled(Popper, {
    name: 'MuiDataGrid',
    slot: 'Panel',
    overridesResolver: function(props, styles) {
        return styles.panel;
    }
})(function(param) {
    var theme = param.theme;
    return {
        zIndex: theme.zIndex.modal
    };
});
var GridPaperRoot = styled(Paper, {
    name: 'MuiDataGrid',
    slot: 'Paper',
    overridesResolver: function(props, styles) {
        return styles.paper;
    }
})(function(param) {
    var theme = param.theme;
    return {
        backgroundColor: (theme.vars || theme).palette.background.paper,
        minWidth: 300,
        maxHeight: 450,
        display: 'flex',
        maxWidth: "calc(100vw - ".concat(theme.spacing(0.5), ")"),
        overflow: 'auto'
    };
});
var GridPanel = forwardRef(function(props, ref) {
    var children = props.children, className = props.className, other = _objectWithoutPropertiesLoose(props, _excluded);
    var apiRef = useGridApiContext();
    var rootProps = useGridRootProps();
    var classes = gridPanelClasses;
    var _React_useState = _sliced_to_array(React.useState(false), 2), isPlaced = _React_useState[0], setIsPlaced = _React_useState[1];
    var handleClickAway = React.useCallback(function() {
        apiRef.current.hidePreferences();
    }, [
        apiRef
    ]);
    var handleKeyDown = React.useCallback(function(event) {
        if (event.key === 'Escape') {
            apiRef.current.hidePreferences();
        }
    }, [
        apiRef
    ]);
    var modifiers = React.useMemo(function() {
        return [
            {
                name: 'flip',
                enabled: true,
                options: {
                    rootBoundary: 'document'
                }
            },
            {
                name: 'isPlaced',
                enabled: true,
                phase: 'main',
                fn: function() {
                    setIsPlaced(true);
                },
                effect: function() {
                    return function() {
                        setIsPlaced(false);
                    };
                }
            }
        ];
    }, []);
    var _React_useState1 = _sliced_to_array(React.useState(null), 2), anchorEl = _React_useState1[0], setAnchorEl = _React_useState1[1];
    React.useEffect(function() {
        var _apiRef_current_rootElementRef_current, _apiRef_current_rootElementRef;
        var panelAnchor = (_apiRef_current_rootElementRef = apiRef.current.rootElementRef) === null || _apiRef_current_rootElementRef === void 0 ? void 0 : (_apiRef_current_rootElementRef_current = _apiRef_current_rootElementRef.current) === null || _apiRef_current_rootElementRef_current === void 0 ? void 0 : _apiRef_current_rootElementRef_current.querySelector('[data-id="gridPanelAnchor"]');
        if (panelAnchor) {
            setAnchorEl(panelAnchor);
        }
    }, [
        apiRef
    ]);
    if (!anchorEl) {
        return null;
    }
    return /*#__PURE__*/ _jsx(GridPanelRoot, _extends({
        placement: "bottom-start",
        className: clsx(classes.panel, className),
        ownerState: rootProps,
        anchorEl: anchorEl,
        modifiers: modifiers
    }, other, {
        ref: ref,
        children: /*#__PURE__*/ _jsx(ClickAwayListener, {
            mouseEvent: "onPointerUp",
            touchEvent: false,
            onClickAway: handleClickAway,
            children: /*#__PURE__*/ _jsx(GridPaperRoot, {
                className: classes.paper,
                ownerState: rootProps,
                elevation: 8,
                onKeyDown: handleKeyDown,
                children: isPlaced && children
            })
        })
    }));
});
process.env.NODE_ENV !== "production" ? GridPanel.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * Popper render function or node.
   */ children: PropTypes.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: PropTypes.object,
    /**
   * If `true`, the component is shown.
   */ open: PropTypes.bool.isRequired,
    ownerState: PropTypes.object
} : void 0;
export { GridPanel };
